module.exports = __webpack_public_path__ + "static/media/journeyTimeline.4b1eef12.png";